export default __webpack_public_path__ + "static/media/menu.1a8df4c1.svg";